import { render } from "./CompanyDetail.vue?vue&type=template&id=fb74e31c&scoped=true"
import script from "./CompanyDetail.vue?vue&type=script&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&lang=js"

import "./CompanyDetail.vue?vue&type=style&index=0&id=fb74e31c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb74e31c"]])

export default __exports__